import { Flame, Smile } from 'lucide-react'
import type { MatchType } from '@/shared/mock/data'
import { Chip } from './chip'

// Casual vs Competitivo play-style badge — the `matchType` axis (distinct from
// privacy). Competitive reads in the accent; casual stays neutral. The label
// today is player-chosen; the rating engine that backs "competitivo" is Phase 3+.
export function MatchTypeBadge({ type }: { type: MatchType }) {
  const competitive = type === 'Competitivo'
  return (
    <Chip className={competitive ? 'text-[color:var(--accent)] border-[var(--accent)]' : ''}>
      {competitive ? <Flame size={13} /> : <Smile size={13} />}
      {type}
    </Chip>
  )
}
